import * as React from 'react';
import './trigonometry-util.scss';

export function getElementCircle(styles?: React.CSSProperties) {
	return <div className="trigonometry-circle" style={styles} />;
}
